export enum AlertTypeEnum {
  minimalBalance = 'minimalBalance',
  declinedAuth = 'declinedAuth',
}
